module.exports = __webpack_public_path__ + "static/media/logo.fde1d5c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comparison-new/logo.svg
// module id = 392
// module chunks = 0